import React from 'react';
import cs from 'classnames'

import PreviewContent from '../preview/preview';

import './card.scss';



const Card = ({
  size,
  url,
  type,
  previewContent,
  poster,
  description,
  title
}) => {
  return (
      <React.Fragment>
        <div className={cs(
            `service-card p-v3-grid-item p-v3-grid-item-${size}`
        )}
        >
          <div className="preview">
            <a href={url} className="preview-url">
              <PreviewContent type={type} content={previewContent} poster={poster} title={title} />
            </a>
          </div>
          <div className={cs(
              "p-v3-grid-item-inner",
              {
                "without-descr": !description
              }
          )}
          >
            <a href={url} className="main-url">
              <div className="title">
                <span dangerouslySetInnerHTML={{__html: title}} />
              </div>
              {
                description &&
                <div className="descr">
                  <span dangerouslySetInnerHTML={{__html: description}} />
                </div>
              }
            </a>
          </div>
        </div>
      </React.Fragment>
  );
}

Card.defaultProps = {
  size: "middle"
}

export default Card;
